import { useEffect, useState } from 'react';
import { Button, Header, Icon, Table } from 'react-frontier';
import { useNavigate } from 'react-router-dom';
import { GroupedItemsByType } from '../SiteClasses';
import { CreateInventoryItemModal } from '../components';
import { useUser } from '../hooks';
import UserAccess from '../UserAccess';
import API from '../API';

interface WarehouseInventoryProps{
	warehouse_id: number,
}

var WarehouseInventory = ({ warehouse_id }: WarehouseInventoryProps)=>{
	var { hasAccess } = useUser();
	var navigate = useNavigate();
	var [types, setTypes] = useState<GroupedItemsByType[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [itemModal, setItemModal] = useState<boolean>(false);

	useEffect(()=>{
		if(!warehouse_id) return;
		get();
	}, [warehouse_id]);

	var get = ()=>{
		setLoadError(null);
		API.getWarehouseItems(warehouse_id, 0, 100).then(res=>{
			if(res.error) return setLoadError(res.message);
			setTypes(res.data.items);
		}).catch(()=> setLoadError('Hubo un error cargando el inventario.'));
	};

	var onTypeClick = (type: GroupedItemsByType)=>{
		navigate(`/warehouses/${warehouse_id}/inventory/type/${type.type_id}`);
	};

	var onItemCreated = ()=>{
		get();
		setItemModal(false);
	};

	var canCreateItems = hasAccess(UserAccess.INVENTORY.CREATE_INVENTORY);

	if(loadError) return <Header text='Error' subtext={loadError}/>;
	if(!types) return <Header text='Cargando' loading/>;

	return <>
		<Table
			striped
			fitted
			style={{ margin: 'auto', marginTop: 15, maxWidth: 600 }}
			title='Inventario'
			headers={['', 'Tipo', 'Total']}
			collapsingIndexes={[0, 2]}
			centeredIndexes={[2]}
			button={canCreateItems && (
				<Button text='Agregar' color='black' iconName='plus-circle' size='small' onClick={()=> setItemModal(true)}/>
			)}
		>
		{types.length ? types.map(t=>(
			<Table.Row
				selectable
				key={t.type_id}
				collapsingIndexes={[0, 2]}
				centeredIndexes={[2]}
				onClick={()=> onTypeClick(t)}
				data={[
					<Icon name={t.type_icon}/>,
					t.type_name,
					t.item_count,
				]}
			/>
		)) : (
			<Table.Cell row colSpan={3} className='empty'>No hay equipos registrados.</Table.Cell>
		)}
		</Table>
		<CreateInventoryItemModal
			open={itemModal}
			onClose={()=> setItemModal(false)}
			warehouse_id={warehouse_id}
			onCreate={onItemCreated}
		/>
	</>;
};

export default WarehouseInventory;
